import Header from "../header/Header";
import Footer from "../footer/Footer";
import Gallery from "../gallery/Gallery";
const Gallerypage = () => {
  return (
    <div>
      <Header />
      <Gallery />
      <Footer />
    </div>
  );
};

export default Gallerypage;
